import { render, staticRenderFns } from "./WikiBreadcrumbs.vue?vue&type=template&id=1f4ce092&"
import script from "./WikiBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./WikiBreadcrumbs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports